import { render } from "./AcxHome.vue?vue&type=template&id=2c992c4d&scoped=true"
import script from "./AcxHome.vue?vue&type=script&lang=js"
export * from "./AcxHome.vue?vue&type=script&lang=js"

import "./AcxHome.vue?vue&type=style&index=0&id=2c992c4d&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c992c4d"]])

export default __exports__